import { parseJson } from 'legacy/lut/classes/helpers/JsonHelper'
import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'
import { IELTFormData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { IPartnerGroupInfo } from 'legacy/lut/classes/models/partner360/IPartnerGroup'
import { IPartnerGroupAdditionalInfo } from 'legacy/lut/components/widgets/public/partner360/ELT/models/IPartnerGroupAdditionalInfo'

import { fetchPartnerData } from '../../../api/partnerData/fetchPartnerData'
import { getPartnerGroupData } from '../../partnerGroups/getPartnerGroupData'
import { fetchFormData } from '../fetchFormData'
import { getBasicEltData } from '../getBasicEltData'

import { makeFormInfo } from './makeFormInfo'

interface IGetFormInfo {
  partnerId: string
  groupData?: IPartnerGroupInfo
  forceUpdate?: boolean
  quarterForSave: number
  yearForSave: number
  existingPartnerGroupInfo?: IPartnerGroupAdditionalInfo
}

const getGroupAdditionalInfo = async (
  groupData?: IPartnerGroupInfo,
  existingPartnerGroupInfo?: IPartnerGroupAdditionalInfo
) => {
  if (existingPartnerGroupInfo) {
    return existingPartnerGroupInfo
  }

  return groupData && groupData.GroupId ? await getPartnerGroupData(groupData) : null
}

export const getFormInfo = async ({
  partnerId,
  forceUpdate = false,
  groupData,
  quarterForSave,
  yearForSave,
  existingPartnerGroupInfo,
}: IGetFormInfo) => {
  const partnerGroupData = await getGroupAdditionalInfo(groupData, existingPartnerGroupInfo)
  const result = makeFormInfo()
  if (partnerGroupData) {
    result.push({ partnerGroupData })
  } else {
    const partnerDataRes = await fetchPartnerData(partnerId)
    result.push({ partnerDataRes })
  }
  const versions = await fetchFormData({
    partnerId,
    forceUpdate,
    groupId: partnerGroupData?.groupId || null,
  })
  if (versions.length > 0) {
    result.push({ showVersionsHandler: true })
  } else {
    const version = versions[0] || ({} as IELTData)
    const parsedVersionFormData = version?.FormData
      ? parseJson<IELTFormData>(version?.FormData)
      : null
    const { formData, item, forceUpdateData } = await getBasicEltData({
      item: version,
      partnerId,
      partnerGroupData,
      fYear: version.FYear || yearForSave,
      fQuarter: version.FQuarter || quarterForSave,
      isRollup: parsedVersionFormData?.IsRollup || 0,
    })
    result.push({ formData })
    result.push({ item })
    result.push({ forceUpdateData })
  }

  return result.data
}
